import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IApiResponse } from '../models/api-response';
import { IAppUrls } from '../models/app-urls';
import { ISessionSettings } from '../models/session-settings';
import { IAppFeaturesSettings } from '../models/app-features-settings';
import { IAlgoliaSearchClientSettings } from '../models/algolia-search-client-settings';
import { IConnectEnumValue } from '../models/connect-enum';
import { AlgoliaEntity } from '../../core/global-search/shared/enums/algolia-entity';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  _configApiBaseUrl = environment.servicesUrl.authentication.endsWith('/')
    ? `${environment.servicesUrl.authentication}api/configurations`
    : `${environment.servicesUrl.authentication}/api/configurations`;

  private appUrls: IAppUrls | null = null;

  constructor(
    private http: HttpClient) {

  }

  public getAppUrls(): Observable<IAppUrls> {
    if (this.appUrls) {
      return of(this.appUrls);
    }

    return this.http
      .get<IApiResponse<IAppUrls>>(`${this._configApiBaseUrl}/app-urls`)
      .pipe(
        map((response) => {
          if (response.success) {
            return response.content;
          } else {
            throw new Error(response.message);
          }
        }),
        catchError((error) => {
          throw(error);
        })
      );
  }

  public getSessionSettings(): Observable<IApiResponse<ISessionSettings>> {
    return this.http
      .get<IApiResponse<ISessionSettings>>(`${this._configApiBaseUrl}/get-session-settings`);
  }

  public getMaintenanceMessage(): Observable<IApiResponse<string>> {
    return this.http
      .get<IApiResponse<string>>(`${this._configApiBaseUrl}/get-maintenance-message`);
  }

  public getAppFeaturesSettings(): Observable<IApiResponse<IAppFeaturesSettings>> {
    return this.http
      .get<IApiResponse<IAppFeaturesSettings>>(`${this._configApiBaseUrl}/get-app-features-settings`);
  }

  public getAlgoliaSearchClientSettings(): Observable<IApiResponse<IAlgoliaSearchClientSettings>> {
    return this.http
      .get<IApiResponse<IAlgoliaSearchClientSettings>>(`${this._configApiBaseUrl}/get-algolia-search-client-settings`);
  }

  public getAlgoliaEntityEnumDto(): Observable<IConnectEnumValue<AlgoliaEntity>[]> {
    return this.http
      .get<IConnectEnumValue<AlgoliaEntity>[]>(`${this._configApiBaseUrl}/get-algolia-entity-enum`);
  }
}
